// TextDecorator.js
import React, { useState, useEffect } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Dekorasi Teks - Dekorasi Nama dan Teks dalam Bahasa Arab dan Inggris";
const DESCRIPTION =
  "Tambahkan sentuhan unik dan estetis pada teks dan nama Anda dalam bahasa Arab atau Inggris menggunakan alat dekorasi teks. Pilih dari berbagai gaya, font, dan simbol untuk menyesuaikan teks dengan mudah. Ideal untuk dekorasi nama dan teks di media sosial, blog, dan desain grafis.";
const KEYWORDS =
  "dekorasi teks, dekorasi nama, dekorasi nama, nama berhias, dekorasi nama, tulisan berhias, dekorasi font, hiasan teks, gaya teks, font, simbol, desain teks, hiasan teks, desain grafis, dekorasi Arab, dekorasi Inggris.";
const OG_URL = "https://do-calculate.com/calculator/id/text-decorator/";
const flipTables = [
  // ... (all flipTables data remains unchanged as it contains special character mappings)
];

function TextDecorator() {
  const getPaddingRight = () => {
    if (window.innerWidth <= 768) {
      return "90px";
    }
    return "150px";
  };
  const style = {
    paddingRight: getPaddingRight(),
  };
  const [inputText, setInputText] = useState("");
  const [decoratedTexts, setDecoratedTexts] = useState([]);
  const defaultPreviewText = "Teks Berhias";
  useEffect(() => {
    generateDecoratedTexts(inputText || defaultPreviewText);
  }, [inputText]);
  const handleInputChange = (event) => {
    const text = event.target.value;
    setInputText(text);
  };
  const generateDecoratedTexts = (text) => {
    if (!text) {
      setDecoratedTexts([]);
      return;
    }
    const decorated = flipTables.map((table) => {
      return text
        .split("")
        .map((char) => table[char] || char)
        .join("");
    });
    setDecoratedTexts(decorated);
  };
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert("Teks berhasil disalin!");
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Alat dekorasi teks kami menawarkan cara sederhana dan efektif untuk mengubah nama
                  dan huruf menjadi bentuk berhias dalam bahasa Arab dan Inggris. Dengan menggunakan
                  alat ini, Anda dapat menghias teks Anda dengan berbagai cara untuk membuatnya lebih
                  menarik dan unik. Pilih dari berbagai gaya, font, dan simbol untuk menyesuaikan
                  teks Anda, baik dalam bahasa Arab maupun Inggris.
                </p>
                <p>
                  <strong>Dekorasi Nama dalam Bahasa Arab dan Inggris:</strong> Alat ini menyediakan
                  berbagai kemungkinan untuk menghias nama dan huruf, membuatnya ideal untuk digunakan
                  di halaman media sosial, blog, dan desain grafis. Anda dapat dengan mudah memasukkan
                  nama atau teks yang diinginkan, memilih hiasan yang sesuai dengan selera Anda, lalu
                  menyalin teks berhias untuk digunakan di mana pun Anda inginkan.
                </p>
                <p>
                  <strong>Penggunaan Dekorasi Teks:</strong> Alat ini dapat digunakan untuk menciptakan
                  efek dekoratif yang menarik untuk teks di postingan media sosial, desain artistik,
                  tanda tangan digital, dan aplikasi lain yang membutuhkan hiasan teks. Nikmati membuat
                  desain teks yang unik dengan hiasan indah yang cocok untuk semua selera.
                </p>
                <p>
                  <strong>Fitur Alat:</strong>- Dekorasi nama dan huruf dalam bahasa Arab dan Inggris
                  - Berbagai gaya dan font yang beragam - Mudah digunakan dan disesuaikan - Kemampuan
                  menggunakan hiasan di berbagai bidang desain dan komunikasi
                </p>
                <p>
                  Gunakan alat dekorasi teks kami untuk mengubah teks Anda menjadi desain yang indah
                  yang mencerminkan selera Anda dan menambahkan sentuhan kreativitas pada proyek Anda.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Masukkan Teks yang Akan Dihias
                </div>
                <hr />
                <br />
                <div className="form-group">
                  <input
                    type="text"
                    value={inputText}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Masukkan teks yang akan dihias di sini"
                  />
                </div>
                <br />
                <hr />
              </div>
              <div className="col-12 col-md-7">
                <div>
                  <h4>Teks Berhias:</h4>
                  <hr />
                  <div
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                    }}
                  >
                    {decoratedTexts.length > 0 ? (
                      decoratedTexts.map((text, index) => (
                        <div
                          key={index}
                          style={{
                            backgroundColor: "#f8f9fa",
                            padding: "10px",
                            marginBottom: "10px",
                            borderRadius: "4px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <span>{text}</span>
                            <div style={style}>
                              <button
                                className="btn btn-success btn-sm"
                                onClick={() => copyToClipboard(text)}
                                style={{
                                  alignItems: "flex-end",
                                }}
                              >
                                Salin
                              </button>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>Masukkan teks untuk menampilkan dekorasi</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <hr />
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              Cara Menggunakan Alat Dekorasi Teks?
            </div>
            <div className="info-section-body">
              <p>Untuk menggunakan alat dekorasi teks, ikuti langkah-langkah berikut:</p>
              <ol>
                <li>
                  Masukkan teks yang ingin Anda hias di kolom yang tersedia di atas halaman.
                </li>
                <li>
                  Pilih dari berbagai gaya dan font yang tersedia. Anda akan menemukan pilihan
                  yang mencakup berbagai desain dekoratif yang sesuai untuk teks Arab dan Inggris.
                </li>
                <li>
                  Lihat teks berhias yang muncul di bagian bawah halaman. Anda dapat melihat
                  perubahan secara langsung setelah memilih gaya yang berbeda.
                </li>
                <li>
                  Salin teks berhias dengan sekali klik pada tombol "Salin" untuk menggunakannya
                  di aplikasi apa pun yang Anda inginkan, seperti postingan media sosial,
                  tanda tangan digital, atau desain grafis.
                </li>
              </ol>
              <p>
                Contoh: Jika Anda ingin menghias nama "Ahmad" dengan font berhias, masukkan di
                kolom, lalu pilih gaya hiasan yang Anda sukai, dan Anda akan mendapatkan hasil
                yang menarik dengan cepat dan mudah.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              Apa Itu Alat Dekorasi Teks?
            </div>
            <div className="info-section-body">
              <p>
                Alat dekorasi teks adalah alat canggih yang memungkinkan Anda menghias teks dan nama
                dengan berbagai gaya dan font untuk menciptakan desain yang menarik dan unik. Baik Anda
                ingin menghias teks dalam bahasa Arab atau Inggris, alat ini menyediakan berbagai pilihan
                untuk menyesuaikan teks dengan cara yang kreatif.
              </p>
              <p>
                Alat ini mencakup berbagai gaya dekoratif yang meliputi font berhias dan simbol khusus.
                Anda dapat memilih dari gaya-gaya ini untuk memberikan sentuhan estetis pada teks Anda,
                membuatnya ideal untuk digunakan dalam postingan media sosial, desain grafis, dan banyak lagi.
              </p>
              <p>
                Contoh: Jika Anda ingin menghias nama "Sara" dengan font yang elegan, Anda dapat menggunakan
                alat ini untuk memilih gaya dekoratif yang menonjolkan nama dengan cara yang menarik,
                membuatnya istimewa dalam desain grafis Anda atau platform media sosial.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default TextDecorator;